import { Heading } from "components/elements";

export const FormCard = ({
    children,
    onSubmit,
    title,
}: {
    children: React.ReactNode;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
    title: React.ReactNode;
}) => {
    return (
        <div className="card mx-auto mt-[10%] flex w-[300px] flex-col items-center justify-center px-6 py-6">
            <Heading className="pb-4">{title}</Heading>
            <form onSubmit={onSubmit} className="flex w-full flex-col gap-2">
                {children}
            </form>
        </div>
    );
};
